import { deleteCollection } from '../api/collectionManager';
export const deleteUserCollectionById = async (collectionId, headers, logger) => {
    return deleteCollection(`collections/${collectionId}`, headers, logger);
};
